import { jsx as _jsx } from "react/jsx-runtime";
import { Select } from '@dixa/lib-shared-habla';
import { useCallback, useEffect, useState } from 'react';
import { queuesApi } from 'apis/queues';
import { usePaginatedEndpoint } from 'utils/apis/pagination/usePaginatedEndpoint';
/** Represents the component for selecting a queue. */
export const QueueSelect = ({ className, selectedQueue, infiniteScroll, onSelect, onToggle, status, }) => {
    const [search, setSearch] = useState({});
    const { arg, asyncStatus, hasNextPage, hasPreviousPage, items: queues, changeArg, nextPage, previousPage, } = usePaginatedEndpoint({
        endpoint: queuesApi.endpoints.readQueues,
        itemsSelector: ({ data: { queues } }) => queues,
        initialArg: {
            is_archived: false,
            sort: { key: 'name', direction: 'asc' },
        },
        infinite: infiniteScroll,
    });
    /** Handles searching the queues. */
    const handleSearch = useCallback((value) => {
        setSearch({ term: value.trim() || undefined });
    }, []);
    /** Handles selecting a queue. */
    const handleSelect = useCallback((queue) => {
        onSelect(queue);
    }, [onSelect]);
    /** Handles toggling the dropdown of the select component. */
    const handleToggle = useCallback((isOpen) => {
        if (isOpen) {
            setSearch({ debounceTime: 0 });
        }
        onToggle === null || onToggle === void 0 ? void 0 : onToggle(isOpen);
    }, [onToggle]);
    /** Handles navigating to the next page. */
    const handleNextPage = useCallback(() => {
        return Promise.resolve(nextPage());
    }, [nextPage]);
    /** Handles navigating to the previous page. */
    const handlePreviousPage = useCallback(() => {
        return Promise.resolve(previousPage());
    }, [previousPage]);
    // Changes the arg when search term changes.
    useEffect(() => {
        var _a;
        if (search.term !== (arg === null || arg === void 0 ? void 0 : arg.searchTerm)) {
            changeArg({
                searchTerm: search.term,
                offset: undefined,
                limit: undefined,
            }, { debounceTime: (_a = search.debounceTime) !== null && _a !== void 0 ? _a : 300 });
        }
        // Don't rely on arg as dependency because we change the arg inside.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [changeArg, search]);
    return (_jsx(Select, { status: status, className: className, emptyMessage: search.term ? 'No queues found' : 'No queues available', items: [...queues], loading: asyncStatus === 'pending', onSearch: handleSearch, onSelect: handleSelect, onToggle: handleToggle, pagination: {
            infinite: infiniteScroll,
            nextEnable: hasNextPage,
            previousEnable: hasPreviousPage,
            onNext: handleNextPage,
            onPrevious: handlePreviousPage,
        }, placeholder: "Select a queue", searchable: true, selectedItems: selectedQueue ? [selectedQueue] : [] }));
};
